export const MenuIcon = ({ ...props }) => {
  return (
    <svg width="25" height="15" viewBox="0 0 35 15" fill="none" {...props}>
      <line y1="1" x2="35" y2="1" stroke="white" strokeWidth="2" />
      <line y1="14" x2="35" y2="14" stroke="white" strokeWidth="2" />
    </svg>
  )
}
